import { render, staticRenderFns } from "./access-token.vue?vue&type=template&id=6211d898&"
import script from "./access-token.vue?vue&type=script&lang=js&"
export * from "./access-token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports